import { render, staticRenderFns } from "./FolhaObraFinalPanel.vue?vue&type=template&id=6689c6db&scoped=true&"
import script from "./FolhaObraFinalPanel.vue?vue&type=script&lang=js&"
export * from "./FolhaObraFinalPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6689c6db",
  null
  
)

export default component.exports